import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import ReportLeave from 'app/containers/HumanResources/LeaveReport'

const ReportLeavePageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_leave)}</PageTitle>
      <ReportLeave />
    </>
  )
}
const ReportLeavePage = memo(ReportLeavePageCpn, isEqual)

export default ReportLeavePage
